import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiActionFigureGeneratorConfig } from '@/data/landingConfig/landingAiActionFigureGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiActionFigureGenerator } from './schemaObject';

interface Props {}
const AiActionFigureGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiActionFigureGenerator} />
			<LandingTemplate
				data={landingAiActionFigureGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiActionFigureGenerator;
